const CLAIM_LINK_COOKIES = ['claimLinkId', 'promo']

// The server sets these cookies for ".<host>" (".passengersfriend.com" for claim.passengersfriend.com) and without
// a domain for localhost and IP addresses. A cookie can only be removed with the domain it was set with, so every
// possible domain of the current host is tried.
function cookieDomains(hostname) {
  const isIp = /^[\d.]+$/.test(hostname) || hostname.includes(':')
  if (isIp || !hostname.includes('.')) return [null]

  const parts = hostname.split('.')
  const domains = parts.slice(0, -1).map((_, index) => `.${parts.slice(index).join('.')}`)
  return [null, ...domains]
}

export function clearClaimLinkCookies() {
  for (const name of CLAIM_LINK_COOKIES) {
    for (const domain of cookieDomains(window.location.hostname)) {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ''}`
    }
  }
}
